<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="culvertPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" multiple color="#fff">
      <v-expansion-panel :value="0" class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
          <h3>Culvert Conditions</h3>
        </v-expansion-panel-title>

        <v-expansion-panel-text eager>
          <v-form ref="culvertConditions" v-model="valid">
            <LabelSelect
              id="sel_Culvert_Condition_Rating"
              label="B.C.04 Culvert Condition Rating"
              showDurationIcon
              :refTable="REFERENCE_TABLE.CONDITION_RATING"
              :isEditable="isEditable"
              :isRequired="isEditable"
              v-model="culvertValue.culvRating"
              :tooltip="getHistDuration(culvertValue.culvRatingDuration, culvertValue.culvRatingDurationChanges)"
              @update:modelValue="
                {
                  culvertConditionUpdated = true;
                  conditionUpdated = true;
                }
              "
            ></LabelSelect>

            <CommentTypeTextField
              v-if="moduleType == MODULE_TYPES.INSPECTION"
              label="Overall Culvert Notes"
              id="field_Overall_Culvert_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.CULVERT"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              @changesDetected="inspectionStore.setDirtyFlag(true)"
            />
            <ManagementCommentTypeTextField
              v-else
              label="Overall Culvert Notes"
              id="field_Overall_Culvert_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.CULVERT"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              :comments="culvertValue.inspectionComments"
              :brkey="culvertValue.brkey"
              :inspectionId="culvertValue.inspectionId"
              @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.CULVERT)"
            />
            <LabelSelect
              id="combustible_Material_Under_Bridge"
              label="SUP.01 Combustible Material Under Bridge"
              :isRequired="isEditable"
              :refTable="REFERENCE_TABLE.MATERIAL_STORED_UNDER"
              :isEditable="isEditable"
              v-model="culvertValue.matStoreUnd"
            ></LabelSelect>

            <CommentTypeTextField
              v-if="moduleType == MODULE_TYPES.INSPECTION"
              label="Overall Combustible Material Under Bridge Notes"
              id="field_Combustible_Material_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_COMMENTS"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              @changesDetected="inspectionStore.setDirtyFlag(true)"
            />
            <ManagementCommentTypeTextField
              v-else
              label="Overall Combustible Material Under Bridge Notes"
              id="field_Combustible_Material_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_COMMENTS"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              :comments="culvertValue.inspectionComments"
              :brkey="culvertValue.brkey"
              :inspectionId="culvertValue.inspectionId"
              @updateComment="
                (comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_COMMENTS)
              "
            />

            <LabelCheckbox
              labelXl="3"
              labelLg="4"
              labelMd="5"
              labelSm="6"
              class="labelCheckbox"
              id="checkbox_New_Coating_Since_Last_Inspection"
              label="SUP.02 New Coating Since Last Inspection"
              :isEditable="isEditable"
              v-model="culvertValue.newPaint"
            >
            </LabelCheckbox>

            <LabelSelect
              id="sel_Protective_Coating_Rating"
              label="SUP.03 Protective Coating Rating"
              showDurationIcon
              :refTable="REFERENCE_TABLE.PAINT_CONDITION_RATING"
              :isEditable="isEditable"
              :isRequired="isEditable"
              v-model="culvertValue.paintCondRate"
              :tooltip="getHistDuration(culvertValue.paintCondRateDuration, culvertValue.paintCondRateDurationChanges)"
              @update:modelValue="
                {
                  protectiveCoatingUpdated = true;
                  conditionUpdated = true;
                }
              "
            ></LabelSelect>

            <LabelSelect
              id="sel_Protective_Coating_Extent_Rating"
              label="SUP.04 Protective Coating (Extent) Rating"
              showDurationIcon
              :isRequired="isEditable"
              :refTable="REFERENCE_TABLE.PAINT_CONDITION_RATING_EXTENT"
              :isEditable="isEditable"
              v-model="culvertValue.paintExtentRate"
              :tooltip="
                getHistDuration(culvertValue.paintExtentRateDuration, culvertValue.paintExtentRateDurationChanges)
              "
              @update:modelValue="
                {
                  protectiveCoatingExtentUpdated = true;
                  conditionUpdated = true;
                }
              "
            ></LabelSelect>
            <CommentTypeTextField
              v-if="moduleType == MODULE_TYPES.INSPECTION"
              label="Overall Protective Coating Notes"
              id="field_Overall_Protective_Coating_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.PAINT_OVERALL"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              @changesDetected="inspectionStore.setDirtyFlag(true)"
            />
            <ManagementCommentTypeTextField
              v-else
              label="Overall Protective Coating Notes"
              id="field_Overall_Protective_Coating_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.PAINT_OVERALL"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              :comments="culvertValue.inspectionComments"
              :brkey="culvertValue.brkey"
              :inspectionId="culvertValue.inspectionId"
              @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.PAINT_OVERALL)"
            />
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel :value="1">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />

          <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />

          <h3>Culvert Details</h3>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row class="ma-0">
            <v-col sm="12" md="12" lg="6">
              <LabelText
                labelXl="6"
                labelLg="7"
                labelMd="7"
                labelSm="7"
                textXl="6"
                textLg="5"
                textMd="5"
                textSm="5"
                id="total_number_of_spans"
                label="G.01 Total Number of Spans"
                v-model="culvertValue.totalNumberOfSpans"
                type="number"
                maxlength="22"
              >
              </LabelText>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col sm="12" md="12" lg="6">
              <LabelText
                labelXl="6"
                labelLg="7"
                labelMd="7"
                labelSm="7"
                textXl="6"
                textLg="5"
                textMd="5"
                textSm="5"
                :isEditable="isEditable"
                id="nbis_Bridge_Length"
                label="B.G.01 NBIS Bridge Length"
                v-model="culvertValue.nbisBridgeLength"
                :roundingFactor="ROUNDING_FACTOR.TENTH"
                type="number"
                appendWith=" ft"
                :maxlength="9"
                :decimalPlaces="1"
              >
              </LabelText>
            </v-col>
            <v-col sm="12" md="12" lg="6">
              <LabelText
                labelXl="6"
                labelLg="7"
                labelMd="7"
                labelSm="7"
                textXl="6"
                textLg="5"
                textMd="5"
                textSm="5"
                id="skew"
                label="B.G.11 Skew"
                v-model="culvertValue.skew"
                type="number"
                :appendWith="SYMBOLS.DEGREE"
              >
              </LabelText>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col sm="12" md="12" lg="6">
              <LabelText
                labelXl="6"
                labelLg="7"
                labelMd="7"
                labelSm="7"
                textXl="6"
                textLg="5"
                textMd="5"
                textSm="5"
                id="maximum_Span_Length"
                label="B.G.03 Maximum Span Length"
                v-model="maxMinSpanLength.maxLength"
                :roundingFactor="ROUNDING_FACTOR.TENTH"
                type="number"
                appendWith=" ft"
                :decimalPlaces="1"
              >
              </LabelText>
            </v-col>
            <v-col sm="12" md="12" lg="6">
              <LabelText
                labelXl="6"
                labelLg="7"
                labelMd="7"
                labelSm="7"
                textXl="6"
                textLg="5"
                textMd="5"
                textSm="5"
                id="minimum_Span_Length"
                label="B.G.04 Minimum Span Length"
                v-model="maxMinSpanLength.minLength"
                type="number"
                appendWith=" ft"
                :roundingFactor="ROUNDING_FACTOR.TENTH"
                :decimalPlaces="1"
              >
              </LabelText>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-row
        class="pt-2"
        v-if="
          culvertValue.brkey &&
          !culvertValue.structureUnits?.filter((u) => u.strUnitLabel !== 'COU' && u.strUnitLabel !== 'CIN')?.length &&
          !cinStructureUnit &&
          !couStructureUnit
        "
        ><v-col class="text-center text-gray-500 py-4">
          <v-label class="noRecordsMessage d-flex justify-center"
            >This structure currently contains no structure unit details.
          </v-label>
        </v-col>
      </v-row>

      <CulvertSpanBySpan
        v-for="structureUnit in culvertValue.structureUnits?.filter(
          (u) => u.strUnitLabel !== 'COU' && u.strUnitLabel !== 'CIN',
        )"
        :key="structureUnit.strUnitLabel"
        ref="culvertSpanBySpanRef"
        :isEditable="isEditable"
        :isExpanded="isExpanded"
        :id="`spanBySpan_${structureUnit?.strUnitKey}`"
        :span="structureUnit"
        :structureHeader="structureHeader"
      />
      <v-expansion-panel :value="2" v-if="cinStructureUnit?.strUnitLabel">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(2)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(2)" icon="fa-solid fa-minus" />
          <h3>Culvert Inlet - Waterway</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <UnderwaterInspection
            :pageValue="INSPECTION_PAGES.CULVERT"
            :isEditable="false"
            :id="`span_${cinStructureUnit?.strUnitKey}_Underwater`"
            :strUnitKey="cinStructureUnit?.strUnitKey"
            :strUnitLabel="cinStructureUnit?.strUnitLabel"
            :legacyStructureType="cinStructureUnit?.legacyStructureType"
        /></v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel :value="3" v-if="couStructureUnit?.strUnitLabel">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(3)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(3)" icon="fa-solid fa-minus" />
          <h3>Culvert Outlet - Waterway</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <UnderwaterInspection
            :pageValue="INSPECTION_PAGES.CULVERT"
            :isEditable="false"
            :id="`span_${couStructureUnit?.strUnitKey}_Underwater`"
            :strUnitKey="couStructureUnit?.strUnitKey"
            :strUnitLabel="couStructureUnit?.strUnitLabel"
            :legacyStructureType="couStructureUnit?.legacyStructureType"
        /></v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { clone } from "@/util/clone";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import { getHistDuration } from "@/composables/util";
import { getMaxMinSpanLength } from "@/composables/spanBySpan";
import CommentTypeTextField from "@/components/common/CommentTypeTextField.vue";
import { INSPECTION_COMMENTS, INSPECTION_PAGES } from "@/constants/Inspections";
import { useConfigStore } from "@/stores/config";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import LabelText from "@/components/common/LabelText.vue";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { useCulvertStore } from "@/components/inspection/store/culvert";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { storeToRefs } from "pinia";
import ManagementCommentTypeTextField from "@/components/common/ManagementCommentTypeTextField.vue";
import CulvertSpanBySpan from "@/components/inspection/spanBySpanComponents/CulvertSpanBySpan.vue";
import { INSPECTION_LINKS_PERMISSIONS } from "@/rbac";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { useUserPermissionStore } from "@/stores/userPermission";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { CULVERT_DETAILS_TABLE_HEADER, CULVERT_DATA } from "@/constants/culvert";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { SNACKBAR_MARKER } from "@/constants/GlobalSnackbar.js";
import { SYMBOLS } from "@/constants/Unicode";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";
import UnderwaterInspection from "@/components/inspection/substructureComponents/UnderwaterInspection.vue";

export default {
  name: "InspectionCulvert",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    const allPanels = [0, 1, 2, 3];
    const culvertSpanBySpanRef = ref(null);
    const isExpanded = ref(true);
    const panel = ref(allPanels);
    const inspectionStore = useInspectionStore();
    const userPermissionStore = useUserPermissionStore();
    let structure = computed(() => inspectionStore.selectedInspection);
    let culvertInformation = ref([]);
    const configStore = useConfigStore();
    let valid = ref(true);
    const culvertStore = useCulvertStore();
    let culvertConditions = ref(null);
    let culvertValue = ref({});
    let cinStructureUnit = ref({});
    let couStructureUnit = ref({});
    const quickSearchStore = useQuickSearchStore();
    const inspectionLinksStore = useInspectionLinksStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    let resetDirty = ref(false);
    const headers = ref(CULVERT_DETAILS_TABLE_HEADER[props.moduleType]);

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(culvertValue.value.brkey),
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(culvertValue.value.brkey),
          );
        }
      },
    });

    const isEditable = computed(() => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        return quickSearchStore.hasQuickSearchSucceeded && culvertValue.value?.brkey && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });

    if (!isEditable.value) {
      panel.value = allPanels;
    }
    const inspCommentMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });
    let culvertConditionUpdated = ref(false);
    let protectiveCoatingUpdated = ref(false);
    let protectiveCoatingExtentUpdated = ref(false);
    let conditionUpdated = ref(false);

    const updateDuration = () => {
      if (!structure.value.inspectionConditionHist) {
        structure.value.inspectionConditionHist = {};
      }
      if (culvertConditionUpdated.value) {
        structure.value.inspectionConditionHist.culvRatingDurationChanges = inspectionStore.setDurationChanges(
          structure.value.inspectionConditionHist.culvRatingDurationChanges,
        );
        structure.value.inspectionConditionHist.culvRatingDuration = inspectionStore.setDuration(
          structure.value.inspectionConditionHist.culvRatingDuration,
          structure.value.inspectionConditionHist.culvRatingDurationChanges,
        );
      }
      if (protectiveCoatingUpdated.value) {
        structure.value.inspectionConditionHist.paintCondRateDurationChanges = inspectionStore.setDurationChanges(
          structure.value.inspectionConditionHist.paintCondRateDurationChanges,
        );
        structure.value.inspectionConditionHist.paintCondRateDuration = inspectionStore.setDuration(
          structure.value.inspectionConditionHist.paintCondRateDuration,
          structure.value.inspectionConditionHist.paintCondRateDurationChanges,
        );
      }

      if (protectiveCoatingExtentUpdated.value) {
        structure.value.inspectionConditionHist.paintExtentRateDurationChanges = inspectionStore.setDurationChanges(
          structure.value.inspectionConditionHist.paintExtentRateDurationChanges,
        );
        structure.value.inspectionConditionHist.paintExtentRateDuration = inspectionStore.setDuration(
          structure.value.inspectionConditionHist.paintExtentRateDuration,
          structure.value.inspectionConditionHist.paintExtentRateDurationChanges,
        );
      }

      culvertConditionUpdated.value = false;
      protectiveCoatingUpdated.value = false;
      protectiveCoatingExtentUpdated.value = false;
      conditionUpdated.value = false;
    };
    async function validate() {
      culvertConditions.value.validate();
    }

    onMounted(async () => {
      await readData();
    });

    const toggleAllPanels = (expandAll) => {
      isExpanded.value = expandAll;
      if (expandAll) {
        panel.value = allPanels;
      } else {
        panel.value = [];
      }
    };

    const setUpdatedComment = (comment, commentType) => {
      const foundComment = culvertValue.value.inspectionComments.find((c) => {
        return c.commentType === commentType;
      });
      if (foundComment) {
        foundComment.notes = comment.notes;
        foundComment.updateUserId = comment.updateUserId;
        foundComment.updateDateTime = comment.updateDateTime;
      } else {
        culvertValue.value.inspectionComments.push(comment);
      }
    };

    const readData = async () => {
      cinStructureUnit.value = {};
      couStructureUnit.value = {};
      culvertValue.value = clone(CULVERT_DATA);
      resetDirty.value = true;
      if (props.moduleType == MODULE_TYPES.MANAGEMENT && structureHeader.value?.BRKEY) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        await culvertStore.loadCulvertObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID,
        );

        culvertValue.value = culvertStore.getCulvertObject();
        getWaterway(culvertValue.value?.structureUnits);
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        await culvertStore.loadCulvertObject(props.moduleType, null, null, structure.value);
        culvertValue.value = culvertStore.getCulvertObject();
        inspectionStore.setDirtyFlag(false);
        getWaterway(structure.value?.structureUnits);
      }
      resetDirty.value = true;
      await validate();
    };

    const saveChanges = async () => {
      if (!valid.value) {
        inspectionStore.setShowValidationSnackbar(true);
      }
      inspectionStore.setShowValidationSnackbar(false);
      const isSuccess = await culvertStore.saveCulvert(props.moduleType, culvertValue.value, structure.value);
      if (isSuccess) {
        if (props.moduleType == MODULE_TYPES.INSPECTION) {
          inspectionStore.setLowestConditionRating();
        } else {
          inspectionLinksStore.isDirty = false;
        }   
        await readData();
      }
      return isSuccess;
    };

    const getWaterway = (structureUnits) => {
      cinStructureUnit.value = structureUnits?.find((u) => u.strUnitLabel === "CIN" && u.within500YRFloodPlain == "1");
      couStructureUnit.value = structureUnits?.find((u) => u.strUnitLabel === "COU" && u.within500YRFloodPlain == "1");
    };

    const cancelChanges = async () => {
      //only called from Inspection Links
      resetDirty.value = true;
      culvertStore.resetPageData();
      culvertValue.value = culvertStore.getCulvertObject();

      // Using this flag to not set the dirty flag in watch
      inspectionLinksStore.isDirty = false;
    };

    const maxMinSpanLength = computed(() => {
      return getMaxMinSpanLength(culvertValue.value.structureUnits, ["C", "V"]);
    });

    const printD491 = () => {
      return { reportPage: "D491-Insp-Culvert-Screen", marker: SNACKBAR_MARKER.CULVERT };
    };

    // watch those objects used in component from structure to warn about unsaved changes
    watch(
      [culvertValue],
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true },
    );

    watch(
      () => [props],
      () => {
        readData();
      },
      { deep: true },
    );

    return {
      maxMinSpanLength,
      ROUNDING_FACTOR,
      structureHeader,
      isExpanded,
      culvertSpanBySpanRef,
      culvertStore,
      SYMBOLS,
      protectiveCoatingUpdated,
      protectiveCoatingExtentUpdated,
      conditionUpdated,
      culvertConditionUpdated,
      updateDuration,
      culvertConditions,
      valid,
      validate,
      headers,
      panel,
      REFERENCE_TABLE,
      isEditable,
      structure,
      INSPECTION_COMMENTS,
      configStore,
      inspCommentMaxLength,
      getHistDuration,
      culvertInformation,
      toggleAllPanels,
      readData,
      saveChanges,
      cancelChanges,
      culvertValue,
      setUpdatedComment,
      MODULE_TYPES,
      printD491,
      inspectionStore,
      INSPECTION_PAGES,
      cinStructureUnit,
      couStructureUnit,
    };
  },
  components: {
    LabelSelect,
    CommentTypeTextField,
    LabelCheckbox,
    LabelText,
    CulvertSpanBySpan,
    ExpandCollapseToggle,
    ManagementCommentTypeTextField,
    ValidationCountsHeader,
    UnderwaterInspection,
  },
};
</script>
<style scoped lang="scss">
.v-data-table :deep(th) {
  margin: 0 auto !important;
  text-align: center !important;
}
</style>
